// extracted by mini-css-extract-plugin
export default {"container":"copy-field_container__5nDgr","btn":"copy-field_btn__dmtC5"};